import { useRef as s, useEffect as i } from "react";
import { useLeafletContext as l } from "./context.js";
function p(u) {
  return function(n) {
    const e = l(), r = u(n, e), { instance: t } = r.current, c = s(n.position), { position: o } = n;
    return i(function() {
      return t.addTo(e.map), function() {
        t.remove();
      };
    }, [
      e.map,
      t
    ]), i(function() {
      o != null && o !== c.current && (t.setPosition(o), c.current = o);
    }, [
      t,
      o
    ]), r;
  };
}
export {
  p as createControlHook
};
